import { NORM_DOC, NORM_NAT, NORM_ST, svOf, type NormView } from './normLogic';
import type { NormDoc, NormNat, NormSt } from './normTypes';
import s from './norms.module.css';
import { useT } from '@hana/i18n';
import './svcdock.i18n';

// Phần dùng chung của Mint-Norms (1536) và Mint-Norms-iPad (1180).
export const initSel = () => (typeof location === 'undefined' ? null : new URLSearchParams(location.search).get('sel'));
export const tile = (color: string) => ({ background: `color-mix(in srgb, ${color} 18%, var(--card))` });
export const pill = (k: NormSt) => ({ color: NORM_ST[k][1], background: NORM_ST[k][2] });

export function Tag({ tip, label, c, bg }: { tip: string; label: string; c: string; bg: string }) {
  return <span className={s.tag} title={tip} aria-label={tip} style={{ color: c, background: bg }}>{label}</span>;
}
export const DocTags = ({ docs }: { docs: NormDoc[] }) => <>{docs.map((d) => <Tag key={d} label={d} tip={`${d} · ${NORM_DOC[d][0]}`} c={NORM_DOC[d][1]} bg={NORM_DOC[d][2]} />)}</>;
export function NatTag({ nat }: { nat: NormNat }) {
  const tr = useT();
  return <Tag label={nat} tip={tr('nrp.def', { nat, v: NORM_NAT[nat][0] })} c={NORM_NAT[nat][1]} bg={NORM_NAT[nat][2]} />;
}
export function Code({ n, w = 54, h = 28 }: { n: Pick<NormView, 'code' | 'sv'>; w?: number; h?: number }) {
  const tr = useT();
  return n.code
    ? <span className={s.code} style={{ width: w, height: h, ...tile(svOf(n.sv)[2]) }} title={tr('nrp.feeCode', { code: n.code })}>{n.code}</span>
    : <span className={s.noCode} style={{ width: w, height: h }} title={tr('nrp.pendingTip')}>{tr('nrp.pending')}</span>;
}

